import { TextSize, Weight } from 'components'

import styled from 'styled-components'

export const NumbersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: 825px;
  gap: 60px;
  padding: 60px 0;
  margin: 0 auto;
`

export const NumberIndicator = styled.div`
  font-size: ${TextSize.h4};
  font-weight: ${Weight.Bold};
  line-height: 104.6%;
  letter-spacing: -1.6px;
  text-align: center;
  width: 100%;
`
